let Users = {
    init() {
        this.bind();
    },

    bind() {
        this.addForm();
        this.form();
        this.delete();
        this.resetPasswordEmail();
    },

    addForm() {
        let _this = this;

        const form = $('#userForm');

        if (form.length) {
            let submitBtn = Ladda.create(form.find('[type=submit]')[0]);

            form.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        window.location.assign('/users/' + response.data.id);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },

    delete() {
        $(document).on('click', '.delete-user', function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "Your will not be able to recover this record!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/users/' + id,
                        {
                            _method: 'delete'
                        },
                        (result) => {
                            if (result.success) {
                                let table = row.closest('table').DataTable();
                                table.row(row).remove().draw();
                                swal(
                                    'Deleted!',
                                    'User has been deleted.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    resetPasswordEmail() {
        $(document).on('click', '.send-password-reset-email', function () {
            let id = $(this).data('id');
            let row = $(this).closest('tr');

            swal({
                title: "Are you sure?",
                text: "You are going to send password reset email to this user!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: "Yes, send it!"
            }).then((result) => {
                if (result.value) {
                    $.post('/users/' + id + '/send-password-reset-email',
                        (result) => {
                            if (result.success) {
                                swal(
                                    'Success!',
                                    'Reset password email has been sent.',
                                    'success'
                                ).then((result) => {

                                });
                            }
                        });
                }
            });
        });
    },

    form() {
        let _this = this;
        const form = $('#userForm');
    },
};

$().ready(function () {
    window.Users = Users;
    window.Users.init();
});
